
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppButton } from '@/components';
import { usePromotionPrototypeAdd } from '@/modules/promotion/prototype/model/add';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.PROTOTYPE.ADD,
    components: { AppFormRow, AppInput, AppCard, AppSelect, AppButton },

    setup() {
        const { model, v$, fetch, validateModel, beforeFetch, rfmGroupOptions, iapOptions, actions } =
            usePromotionPrototypeAdd();

        onMounted(async () => {
            await beforeFetch();
            await fetch();
        });

        return { v$, model, validateModel, fetch, rfmGroupOptions, iapOptions, actions };
    }
});
